module.exports = __webpack_public_path__ + "img/vertical_5_1_0.f1956a5a.png";